import { gql } from '@apollo/client'

export const USER_FOLLOW_TOPIC = gql`
  mutation UserFollowTopic($input: SubscribeTopicInput!) {
    subscribeTopic(input: $input) {
      message
      status
    }
  }
`

export const USER_UNFOLLOW_TOPIC = gql`
  mutation UserUnfollowTopic($input: SubscribeTopicInput!) {
    unsubscribeTopic(input: $input) {
      message
      status
    }
  }
`
